module.exports = __webpack_public_path__ + "media/images/emblems/Kammersrohr-blason-f3e5712ba1537f0eb914da094556adcf.svg";